export class CModelUtilities {
  static $inject = ["iso4217"];

  constructor(private iso4217: any) { }

  // Get the currency symbol based on the ISO code:
  formatCurrency(currencyCode: string) {
    var currencySymbol = this.iso4217.getCurrencyByCode(currencyCode).symbol + ' ';
    return currencySymbol;
  }

  // Get the line item's portfolio value
  // Portfolio Value = price * quantity
  getPortfolioValue(lineItem: any) {
    return lineItem.price * lineItem.quantity;
  }

  // Get the difference between the model % and the SEMDEX %
  // Delta = model% - SEMDEX(actual)%
  getDelta(lineItem: any) {
    return lineItem.modelPercentage - lineItem.semdexPercentage;
  }

  // Get the NAV (total) value
  // NAV = sum of all the line items' portfolio values
  getCModelTotal(cModel: any) {
    let cModelTotal = 0;
    let itemList = cModel['cModelItems'];
    for (var item of itemList) {
      cModelTotal += this.getPortfolioValue(item);
    }
    return cModelTotal;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/cmodel.utilities.ts